enum CohabitationEnum {
    SPOUSE = "SPOUSE",
    PARTNER = "PARTNER",
    OTHER = "OTHER",
    ALONE = "ALONE",
}

export default CohabitationEnum;
